"use client";

import React from "react";
import { useStepperContext } from "./stepper-provider";
import { cn } from "@/lib/utils";
import { Tabs, TabsContent, TabsList, TabsTrigger } from "@/components/ui/tabs";
import { UseFormReturn } from 'react-hook-form';
import SecondaryPackageDetails from '@/components/distribution-analytics/secondary-package-details';
import TertiaryPackageDetails from '@/components/distribution-analytics/tertiary-package-details';
    import { useLocation } from "react-router-dom";
interface StepperProps {
    form?: UseFormReturn<any>;
}

const Stepper: React.FC<StepperProps> = ({ form }) => {
    const { currentStep, steps, handleStepClick, isStepDisabled } = useStepperContext();
    const hasTertiaryPackage = form?.watch('has_tertiary_package');
    const pathname = useLocation();

    const renderPackageContent = () => (
        <div className="mt-4">
            <Tabs defaultValue="secondary" className="w-full">
                <TabsList className="grid w-full grid-cols-2">
                    <TabsTrigger value="secondary" className="text-lg">Secondary*</TabsTrigger>
                    <TabsTrigger
                        value="tertiary"
                        className="text-lg"
                        disabled={hasTertiaryPackage !== 'yes'}
                    >
                        Tertiary
                    </TabsTrigger>
                </TabsList>
                <TabsContent value="secondary">
                    {form && <SecondaryPackageDetails form={form} />}
                </TabsContent>
                <TabsContent value="tertiary">
                    {form && hasTertiaryPackage === 'yes' && <TertiaryPackageDetails form={form} />}
                </TabsContent>
            </Tabs>
        </div>
    );

    return (
        <>
            <div className="w-full h-[65px] flex items-center relative justify-around gap-0 sm:gap-2 shadow-md overflow-x-auto scrollbar-hide">
                {steps.map((step, index) => (
                    <React.Fragment key={step.id}>
                        <div className="flex items-center bg-white relative min-w-fit gap-1 sm:gap-3">
                            <div
                                className={cn(
                                    "flex items-center gap-2 py-2 sm:py-5 px-1 sm:px-2",
                                    (currentStep === step.id ||
                                        (currentStep === 'distribution' && step.id === 'pallet') ||
                                        (currentStep === 'pallet' && step.id === 'distribution'))
                                    && "border-b-2 border-blue"
                                )}
                            >
                                <div
                                    className={cn(
                                        "size-4 sm:size-6 flex-center rounded-full",
                                        step.isCompleted
                                            ? "bg-states-success"
                                            : (currentStep === step.id || ((currentStep === 'distribution' && step.id === 'pallet') || (currentStep === 'pallet' && step.id === 'distribution')))
                                                ? "border-2 border-states-warning bg-white"
                                                : "bg-stepper-inactive"
                                    )}
                                >
                                    {(currentStep === step.id || ((currentStep === 'distribution' && step.id === 'pallet') || (currentStep === 'pallet' && step.id === 'distribution'))) && (
                                        <span className="size-1 sm:size-2 rounded-full bg-states-warning "></span>
                                    )}
                                </div>

                                <button
                                    onClick={() => handleStepClick(step.id)}
                                    // disabled={isStepDisabled(step.id)}
                                    disabled={step.id !== 'define' && pathname.pathname.includes('new-project')}
                                    className={cn(
                                        "semi-bold-16 text-placeholder relative whitespace-nowrap text-xs sm:text-sm",
                                        currentStep === step.id && "text-blue",
                                        step.isCompleted && "text-blue",
                                        (step.id !== 'define' && pathname.pathname.includes('new-project')) && "cursor-not-allowed opacity-50"
                                    )}
                                >
                                    <span className="hidden sm:inline">{step.label}</span>
                                    <span className="sm:hidden">{step.icon}</span>
                                    <span className="absolute left-0 -bottom-6 bg-white p-1 rounded shadow-md opacity-0 group-hover:opacity-100 transition-opacity duration-200 text-xs whitespace-nowrap z-10">
                                        {step.title}
                                    </span>
                                </button>
                            </div>

                            {index < steps.length - 1 && (
                                <div
                                    className={cn(
                                        "transition-all duration-150 hidden sm:block ease-in-out w-[10px] sm:w-[15px] md:w-[20px] lg:w-[25px] xl:w-[30px] mt-2 h-2 border-dashed border-t-2 border-grey",
                                        step.isCompleted && "border-blue border-solid"
                                    )}
                                />
                            )}
                        </div>
                    </React.Fragment>
                ))}
            </div>

            {currentStep === 'package' && form && renderPackageContent()}
        </>
    );
};

export default Stepper;
